module.exports = __webpack_public_path__ + "img/bg.01de9390.png";